import React from 'react';
import { MapPin } from 'lucide-react';

export default function AddressSection({ savedAddress, setSavedAddress, savingAddress, handleSaveAddress }) {
  return (
    <div className="space-y-6">
      <div className="bg-white p-6 rounded-lg border border-gray-200">
        <h3 className="font-serif text-xl font-semibold text-[#1a3a5c] mb-2">Shipping Address</h3>
        <p className="text-sm text-gray-600 mb-6">This address will be auto-filled during checkout</p>
        <form onSubmit={handleSaveAddress} className="space-y-4" data-testid="address-form">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
              <input type="text" value={savedAddress.name} onChange={(e) => setSavedAddress({ ...savedAddress, name: e.target.value })} placeholder="Enter full name" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C9A967] focus:border-transparent" data-testid="address-name" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
              <input type="tel" value={savedAddress.phone} onChange={(e) => setSavedAddress({ ...savedAddress, phone: e.target.value })} placeholder="Enter phone number" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C9A967] focus:border-transparent" data-testid="address-phone" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Street Address</label>
            <input type="text" value={savedAddress.street} onChange={(e) => setSavedAddress({ ...savedAddress, street: e.target.value })} placeholder="House no., building, street, area" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C9A967] focus:border-transparent" data-testid="address-street" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">City</label>
              <input type="text" value={savedAddress.city} onChange={(e) => setSavedAddress({ ...savedAddress, city: e.target.value })} placeholder="City" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C9A967] focus:border-transparent" data-testid="address-city" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">State</label>
              <input type="text" value={savedAddress.state} onChange={(e) => setSavedAddress({ ...savedAddress, state: e.target.value })} placeholder="State" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C9A967] focus:border-transparent" data-testid="address-state" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Pincode</label>
              <input type="text" value={savedAddress.pincode} onChange={(e) => setSavedAddress({ ...savedAddress, pincode: e.target.value })} placeholder="Pincode" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#C9A967] focus:border-transparent" data-testid="address-pincode" />
            </div>
          </div>
          <button type="submit" disabled={savingAddress} className="px-6 py-2.5 bg-[#1a3a5c] text-white rounded-lg hover:bg-[#1f4268] transition-colors disabled:opacity-50" data-testid="save-address-btn">
            {savingAddress ? 'Saving...' : 'Save Address'}
          </button>
        </form>
      </div>
    </div>
  );
}
